'use client';

import React__default from 'react';
import { FooterContainer, AgreePrivacyPolicy, ErrorMessage } from '../style.css.js';
import Button from '../../Button/index.js';
import LoadingIcon from '../../Images/LoadingIcon/index.js';
import { colors } from '../../Colors/index.js';
import { ELanguage } from '../../Utils/constants.js';
import CheckBox from '../../CheckBox/index.js';

function Footer(_a) {
    var _b;
    var isLoading = _a.isLoading, lang = _a.lang, _c = _a.isMobile, isMobile = _c === void 0 ? false : _c, privacyPolicies = _a.privacyPolicies, privacyErrorState = _a.privacyErrorState, checkedPrivacyPolicyState = _a.checkedPrivacyPolicyState, t = _a.t, onClick = _a.onClick;
    var isPrivacyError = privacyErrorState[0], setPrivacyError = privacyErrorState[1];
    var isCheckedPrivacyPolicy = checkedPrivacyPolicyState[0], setCheckedPrivacyPolicy = checkedPrivacyPolicyState[1];
    return (React__default.createElement(FooterContainer, null,
        isMobile && privacyPolicies.length > 0 && (React__default.createElement(AgreePrivacyPolicy, { isMobile: true },
            React__default.createElement(CheckBox, { state: isCheckedPrivacyPolicy ? 'checked' : 'none', onCheckChange: function (value) {
                    setCheckedPrivacyPolicy(value === 'checked');
                    setPrivacyError(false);
                }, label: React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("span", null, t('I agree to the')),
                    ' ',
                    React__default.createElement("a", { target: '__blank', href: privacyPolicies && (privacyPolicies === null || privacyPolicies === void 0 ? void 0 : privacyPolicies.length) > 0
                            ? (_b = privacyPolicies[0]) === null || _b === void 0 ? void 0 : _b.fileUrl
                            : '#', onClick: function (e) {
                            var _a;
                            e.stopPropagation();
                            window.open(privacyPolicies && (privacyPolicies === null || privacyPolicies === void 0 ? void 0 : privacyPolicies.length) > 0
                                ? (_a = privacyPolicies[0]) === null || _a === void 0 ? void 0 : _a.fileUrl
                                : '#', '_blank');
                        } }, t('Privacy Policy')),
                    ' ',
                    React__default.createElement("span", null, t('of this employer.')),
                    React__default.createElement("span", { className: 'required' }, "(*)")) }),
            isPrivacyError && (React__default.createElement(ErrorMessage, null, t('Please tick the checkbox if you want to proceed.'))))),
        React__default.createElement(Button, { type: 'primary', onClick: onClick, disabled: isLoading },
            isLoading && React__default.createElement(LoadingIcon, { bgColor: colors.grey[80] }),
            lang === ELanguage.VI ? 'Nộp Đơn' : 'Apply')));
}

export { Footer as default };
//# sourceMappingURL=Footer.js.map
